<template>
<body>
    <div style="background-color:#ffffff">

        <v-container>
            <Productos :title="title" :imgproducto="imgproducto" :txt1="txt1" :contenidos="contenidos" :txt2="txt2" :txt3="txt3" :ventas="ventas" :id="id" :txt4="txt4">
            </Productos >
            
       </v-container>
         

    </div>
    </body>
</template>


<script>
import Productos from "@/components/Productos.vue"

export default {
   
    components:{
       Productos
     },

    data(){
        return{
            id:"kit2",
            title:"Valores en acción 2",
            imgproducto:"programaescolar_contenido2k.png",
            txt1:"El programa Lalabum preescolar se utiliza como libro escolar o para escuela en casa.",
            contenidos:[
             {title:"Libro de actividades Lalabum Valores en acción con contenidos recortables y juegos para utilizar en cada clase."},
             {title:"Acceso a la plataforma de maestros o padres de familia para descargar los contenidos de clase como: planeaciones, canciones,cuentos y videos."},
             {title:"Suscripción por 12 meses a la app educativa y bilingüe “Mundo Lalabum” que complementa los aprendizajes del libro."},
            
           ],
           txt2:"Ofrece contenido para trabajar durante 36 semanas o un ciclo escolar con un temario basado de acuerdo a la edad del niño.",
           txt3:"“Valores en acción 2” trabaja con el desarrollo Desarrollo de autonomía, expresión de las emociones, respeto a la autoridad, modales y disciplina para niños de 4 a 5 años.",
           txt4:"Al utilizar este programa de actividades Lalabum, tus niños realizan dinámicas y juegos guiados para aprender y practicar buenas acciones a través de ejemplos modernos de situaciones cotidianas que les ayudan a descubrir el beneficio de usar sus valores todos los días. Incluye:",
           ventas:[
             {comercio:"Mercado Libre",url:"https://cutt.ly/FgYJpas"},
             {comercio:"Paypal",url:"https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=555ZVFNSSURDA"},
             /*{comercio:"Gonvil",url:"https://cutt.ly/4gYJovD"},
             {comercio:"Delti",url:"https://cutt.ly/4gYJovD"}*/
           ]
        }
    }
}
</script>

<style scoped>
.description.kit2,.producto.kit2{
    color:#50b05e;
}
</style>


